import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { MaskWrapper, MaskCharacter } from './styles/MaskInput.styles';

const MaskInputControl = ({ control, renderMode }) => (
  <ObjectWrapper>
    <MaskWrapper
      styleProps={control.attributes}
      renderMode={renderMode}
      height={control.height}
    >
      {(control.placeholder || '').split('').map((char, index) => (
        <MaskCharacter
          key={index}
          isPlaceholder={char === '#'}
          styleProps={control.attributes}
          renderMode={renderMode}
        >
          {char}
        </MaskCharacter>
      ))}
    </MaskWrapper>
  </ObjectWrapper>
);

export default MaskInputControl;